import { busyWhile } from "lib/@components/busy/busy-while.js"
import { getSchedule } from "routes/schedule/lib/get-schedule.js"

/* gets originating scheduleId and code from the source schedule.
 *
 * source schedule is either the schedule you are directly 'deriving' (tailored copy) from,
 * or the original schedule the one you are copying IS ALREADY derived from.
 *
 * schedule info requires a request, so wrapped in busyWhile
 */
export async function getOriginatingSchedule(sourceScheduleId) {
    const sourceSchedule = await busyWhile(() => getSchedule(sourceScheduleId), "Reading the schedule")
    return {
        originatingScheduleId: sourceSchedule?.originatingScheduleId ?? sourceSchedule?._id,
        originatingScheduleCode: sourceSchedule?.originatingScheduleCode ?? sourceSchedule?.code,
    }
}
